const Config = {
  // API_BASE_URL: "https://api.simfinanceghana.com/api",
  API_BASE_URL: "https://api.infoboxx.com/api",
  APP_NAME: "Infoboxx",
  APP_VERSION: "1.0.0",
  TOKEN_KEY: "infoboxx_consumer_tkn",
  USER_KEY: "infoboxx_consumer",
  DEFAULT_PAGE_SIZE: 10,
  MAX_FILE_SIZE: 5 * 1024 * 1024,
  SUPPORTED_IMAGE_TYPES: ["image/jpeg", "image/png", "image/jpg", "image/webp"],
  DATE_FORMAT: "DD/MM/YYYY",
  DATE_TIME_FORMAT: "DD/MM/YYYY HH:mm",
  CURRENCY: "GHS",
  LOCALE: "en-GH",
};

export default Config;
